import { render, staticRenderFns } from "./Recovery.vue?vue&type=template&id=2df5bc62&scoped=true"
import script from "./Recovery.vue?vue&type=script&lang=js"
export * from "./Recovery.vue?vue&type=script&lang=js"
import style0 from "./Recovery.vue?vue&type=style&index=0&id=2df5bc62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df5bc62",
  null
  
)

export default component.exports